import React from 'react';
import { Check, CreditCard } from 'lucide-react';
import { formatNumberWithCommas } from './utils/creditUtils';

interface CreditPackageCardProps {
  id: string;
  name: string;
  amount: number;
  price: number;
  popular?: boolean;
  isSelected: boolean;
  onSelect: (id: string) => void;
}

export const CreditPackageCard: React.FC<CreditPackageCardProps> = ({
  id,
  name,
  amount,
  price,
  popular = false,
  isSelected,
  onSelect,
}) => {
  return (
    <div
      className={`border-2 rounded-lg p-4 transition-all duration-200 cursor-pointer relative ${
        isSelected
          ? 'border-blue-500 bg-blue-50 shadow-lg ring-2 ring-blue-200'
          : 'border-gray-300 bg-white hover:border-blue-400 hover:bg-blue-25 hover:shadow-md'
      }`}
      onClick={() => onSelect(id)}
    >
      {popular && (
        <div className="absolute top-0 right-0 -translate-y-1/2 translate-x-0">
          <span className="bg-gradient-to-r from-blue-500 to-purple-600 text-white text-xs font-medium px-3 py-1 rounded-full shadow-md">
            Popular
          </span>
        </div>
      )}

      <div className="flex items-start justify-between">
        <div className="flex-1">
          <h3 className="font-semibold text-gray-900 text-lg">{name} Package</h3>
          <div className="mt-2 flex items-baseline">
            <span className="text-3xl font-bold text-gray-900">{formatNumberWithCommas(amount)}</span>
            <span className="ml-1 text-sm font-medium text-gray-600">credits</span>
          </div>
          <div className="mt-1 text-lg font-semibold text-green-600">
            ${formatNumberWithCommas(price)} USD
          </div>
          <div className="mt-2 text-sm font-medium text-blue-600 bg-blue-50 px-2 py-1 rounded-md inline-block">
            Tradeable AUM: ${formatNumberWithCommas(amount * 1000)}
          </div>
        </div>

        <div className="flex-shrink-0 ml-4">
          {isSelected ? (
            <div className="h-8 w-8 rounded-full bg-blue-500 flex items-center justify-center shadow-md">
              <Check className="h-5 w-5 text-white" />
            </div>
          ) : (
            <div className="h-8 w-8 rounded-full border-2 border-gray-400 bg-white hover:border-blue-400 transition-colors"></div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CreditPackageCard;
